"use strict";

angular.module("app.elements.referral", [])
  .directive("viReferral", function () {
    return {
      templateUrl: "app/js/modules/elements/referral/referral.html"
    };
  });
